/**
 * Sorts manifests based on a 'recommended' list.
 * It creates an empty array with empty slots
 * to avoid calculating indexes multiple times;
 * unused slots are filtered at the end.
 *
 * @param  {Manifest} manifests
 * @param  {precision.cdns} recommendedCdns
**/

const mapToRecommendedCdns = (manifests, recommendedCdns = []) => {
    const sortedManifests = manifests
        .reduce((output, nextManifest) => {
            const [recommended, notRecommended] = output;
            const recommendedCdnIndex = recommendedCdns.indexOf(nextManifest.name);

            recommendedCdnIndex > -1
                ? recommended.splice(recommendedCdnIndex, 1, nextManifest)
                : notRecommended.push(nextManifest);

            return output;
        }, [Array(recommendedCdns.length),[]]);

    const [recommended, notRecommended] = sortedManifests;

    return recommended.concat(notRecommended).filter(Boolean);
};



export default mapToRecommendedCdns;
